/**
 * FoldedCorner — the shared active-state language for picker tiles.
 * A small folded gold triangle anchored to the top-right of its parent.
 *
 * Defined once here so StylePicker, NewGeneration, WhalePicker, and any
 * future picker stop forking their own copy.
 */
export function FoldedCorner({ size = 16 }: { size?: number }) {
  return (
    <svg
      aria-hidden="true"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      className="pointer-events-none absolute right-0 top-0"
    >
      <path d="M16 0 L16 16 L0 0 Z" fill="rgb(var(--color-accent))" />
      <path d="M16 0 L8 8 L16 16" fill="rgb(var(--color-accent-soft))" />
      <path
        d="M16 0 L0 0 L16 16"
        fill="none"
        stroke="rgb(var(--color-accent-deep) / 0.55)"
        strokeWidth="0.5"
      />
    </svg>
  );
}
